import React from 'react';
import { FaFacebookF, FaLinkedinIn, FaPhoneAlt, FaCalendarAlt } from 'react-icons/fa';

const Footer = ({refs}) => {
  const { homeRef, aboutRef, servicesRef, contactRef } = refs;
  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <footer className="bg-[#030E2C] text-white relative pb-20">
      {/* Top Social & Logo Section */}
      <div className="bg-[#00172d] w-full py-6 px-10 flex flex-col lg:flex-row justify-between items-center">
        <div className="flex space-x-4">
          <div className="bg-[#1C2D4E] p-3 rounded-full hover:bg-[#F97316]"><FaFacebookF /></div>
          {/* <div className="bg-[#1C2D4E] p-3 rounded-full hover:bg-[#F97316]"><FaTwitter /></div> */}
          <div className="bg-[#1C2D4E] p-3 rounded-full hover:bg-[#F97316]"><FaLinkedinIn /></div>
          {/* <div className="bg-[#1C2D4E] p-3 rounded-full hover:bg-[#F97316]"><FaBehance /></div> */}
        </div>
        <div className="text-center my-4 lg:my-0">
          <img src="/WhitLogo.png" alt="OkacAir Logo" className="h-14 mx-auto mb-2" />
          {/* <h1 className="text-3xl font-bold">OkacAir</h1> */}
          {/* <p className="text-[#F97316] font-semibold">Repairing Services</p> */}
        </div>
        <div className="flex items-center space-x-4">
          <div className="bg-white text-[#F97316] p-3 rounded-full">
            <FaPhoneAlt />
          </div>
          <div>
            {/* <p className="text-sm text-gray-300">Need Any Cleaning Help</p> */}
            <p className="text-lg font-semibold">+91 9211266200</p>
          </div>
        </div>
      </div>

      {/* Middle Info Section */}
      <div className="flex flex-col lg:flex-row justify-between gap-8 px-10 py-10">
        {/* Services */}
        <div className="flex flex-col mb-8 lg:mb-0">
          <h2 className="text-xl font-semibold mb-2 border-[#F97316] inline-block">Our Service</h2>
          <div className='flex items-center gap-1 mb-4'>
            <div className='w-[60px] h-[4px] rounded-full bg-orange-500'></div>
            <div className='w-[20px] h-[4px] rounded-full bg-white'></div>
            <div className='w-[5px] h-[5px] rounded-full bg-white'></div>
          </div>
          <ul className="space-y-2 list-disc list-inside">
            <li className='hover:text-orange-500 duration-200'>Ac Repair & Services</li>
            <li className='hover:text-orange-500 duration-200'>Ac Gas Filling</li>
            <li className='hover:text-orange-500 duration-200'>Ac Installation</li>
            <li className='hover:text-orange-500 duration-200'>Ac Replacement</li>
            <li className='hover:text-orange-500 duration-200'>Ac on Rent</li>
          </ul>
        </div>

        {/* Working Hours */}
        <div className="flex flex-col mb-8 lg:mb-0">
          <h2 className="text-xl font-semibold mb-2 border-[#F97316] inline-block">Working Hours:</h2>
          <div className='flex items-center gap-1 mb-4'>
            <div className='w-[60px] h-[4px] rounded-full bg-orange-500'></div>
            <div className='w-[20px] h-[4px] rounded-full bg-white'></div>
            <div className='w-[5px] h-[5px] rounded-full bg-white'></div>
          </div>
         <ul className="space-y-2">
  <li className="flex justify-between gap-8">
    <span>Monday</span><span>10:00 AM – 7:00 PM</span>
  </li>
  <li className="flex justify-between gap-8">
    <span>Tuesday</span><span>10:00 AM – 7:00 PM</span>
  </li>
  <li className="flex justify-between gap-8">
    <span>Wednesday</span><span>10:00 AM – 7:00 PM</span>
  </li>
  <li className="flex justify-between gap-8">
    <span>Thursday</span><span>10:00 AM – 7:00 PM</span>
  </li>
  <li className="flex justify-between gap-8">
    <span>Friday</span><span>10:00 AM – 7:00 PM</span>
  </li>
  <li className="flex justify-between gap-8">
    <span>Saturday</span><span>10:00 AM – 7:00 PM</span>
  </li>
  <li className="flex justify-between gap-8">
    <span>Sunday</span><span>10:00 AM – 7:00 PM</span>
  </li>
</ul>

        </div>

        {/* Quick Links */}
        <div className="flex flex-col mb-8 lg:mb-0">
          <h2 className="text-xl font-semibold mb-2 border-[#F97316] inline-block">Quick links</h2>
          <div className='flex items-center gap-1 mb-4'>
            <div className='w-[60px] h-[4px] rounded-full bg-orange-500'></div>
            <div className='w-[20px] h-[4px] rounded-full bg-white'></div>
            <div className='w-[5px] h-[5px] rounded-full bg-white'></div>
          </div>
          <ul className="space-y-2 list-disc list-inside">
            <li onClick={() => scrollToSection(homeRef)} className='hover:text-orange-500 duration-200'>Home</li>
            <li onClick={() => scrollToSection(aboutRef)} className='hover:text-orange-500 duration-200'>About</li>
            <li onClick={() => scrollToSection(servicesRef)} className='hover:text-orange-500 duration-200'>Services</li>
            {/* <li className='hover:text-orange-500 duration-200'>Blog</li> */}
            <li onClick={() => scrollToSection(contactRef)} className='hover:text-orange-500 duration-200'>Contact</li>
          </ul>
        </div>

        {/* Recent Post */}
        <div className="flex flex-col">
          <h2 className="text-xl font-semibold mb-2 border-[#F97316] inline-block">Recent Post</h2>
          <div className='flex items-center gap-1 mb-4'>
            <div className='w-[60px] h-[4px] rounded-full bg-orange-500'></div>
            <div className='w-[20px] h-[4px] rounded-full bg-white'></div>
            <div className='w-[5px] h-[5px] rounded-full bg-white'></div>
          </div>
          <div className="space-y-4">
            <div className="flex">
              <img src="/recent_post_1.webp" className="mr-4 w-16 h-16 object-cover" alt="Post 1" />
              <div>
                <p className="text-xs flex items-center gap-1"><FaCalendarAlt /> 12 May, 2024</p>
                <p className="text-sm font-semibold hover:text-orange-500 duration-200">Outdoor and Landscape Lighting</p>
              </div>
            </div>
            <div className="flex">
              <img src="/recent_post_2.webp" className="mr-4 w-16 h-16 object-cover" alt="Post 2" />
              <div>
                <p className="text-xs flex items-center gap-1"><FaCalendarAlt /> 10 May, 2024</p>
                <p className="text-sm font-semibold hover:text-orange-500 duration-200">Panel Upgrades and Maintenance</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bg-orange-600  w-full absolute md:bottom-0 text-white flex flex-col lg:flex-row justify-between items-center px-10 py-4">
        <p>Copyright@ 2025 <span className='text-black'>OKAC.</span> All Rights Reserved.</p>
        <div className="flex gap-4 text-sm mt-2 lg:mt-0">
          <span className='hover:text-gray-800 duration-200'>Setting & Privacy</span>
          <span className='hover:text-gray-800 duration-200'>• FAQ</span>
          <span className='hover:text-gray-800 duration-200'>• Support</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
